import { render, staticRenderFns } from "./ModalThx.vue?vue&type=template&id=dd99682e"
import script from "./ModalThx.vue?vue&type=script&lang=js"
export * from "./ModalThx.vue?vue&type=script&lang=js"
import style0 from "./ModalThx.vue?vue&type=style&index=0&id=dd99682e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports